import * as model from './model.js';
import navView from './views/navView.js';
import homeView from './views/homeView.js';
import sliderView from './views/sliderView.js';
import moviesView from './views/moviesView.js';
import searchBookmarksView from './views/searchBookmarksView.js';
import modalView from './views/modalView.js';
import errorView from './views/errorView.js';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { async } from 'regenerator-runtime';
// import { entries } from 'core-js/core/array';

// Home
const controlHome = function () {
  // If user is at home screen, only scroll to top
  if (model.state.currentView === 'home') {
    homeView.scrollToTop();
    return;
  }

  // If user is not at home screen, render home screen / Render home when page loads
  controlInitHome();
};

const controlInitHome = function () {
  // Setting currentView to 'home'
  model.setView('home');

  // Rendering home movies/shows
  homeView.render();

  // Initializing slider, movie rows, navbar
  initSlider();
  initMovies();
  initNavbar();

  homeView.scrollToTop();
};

// Navbar
const initNavbar = function () {
  navView.setSliderElement();
  navView.observeSlider(controlNavDisplay);
  navView.addHandlerLogoClick(controlHome);
  navView.addHandlerSearch(controlSearch);
  navView.addHandlerBookmarks(controlRenderBookmarks);
};

const controlNavDisplay = function (entry) {
  if (
    model.state.currentView === 'results' ||
    model.state.currentView === 'bookmarks'
  ) {
    navView.toggleFixed(false);
    return;
  }

  if (model.state.currentView === 'home') {
    !entry.isIntersecting
      ? navView.toggleFixed(true)
      : navView.toggleFixed(false);
  }
};

// Slider
const initSlider = function () {
  sliderView._initParent();
  sliderView.render();
  sliderView.initElements();
  model.setMaxSlide(sliderView.getSlidesCount());
  sliderView.initialDotsRender(model.state.slider.maxSlide);
  model.state.slider.currentSlide = 0;
  sliderView.slidesMove(0);
  sliderView.addHandlerPrevious(controlPreviousSlide);
  sliderView.addHandlerNext(controlNextSlide);
  stopAutoSlide();
  startAutoSlide();
  sliderView.addHandlerDots(controlGoToSlide);
};

const controlPreviousSlide = function () {
  // Stop timer
  stopAutoSlide();

  // Move slide
  model.state.slider.currentSlide === 0
    ? (model.state.slider.currentSlide = model.state.slider.maxSlide)
    : model.state.slider.currentSlide--;

  sliderView.slidesMove(model.state.slider.currentSlide);

  // Start timer again
  startAutoSlide();
};

const controlNextSlide = function () {
  // Stop timer
  stopAutoSlide();

  // Move slide
  model.state.slider.currentSlide === model.state.slider.maxSlide
    ? (model.state.slider.currentSlide = 0)
    : model.state.slider.currentSlide++;

  sliderView.slidesMove(model.state.slider.currentSlide);

  // Start timer again
  startAutoSlide();
};

const controlGoToSlide = function (slide) {
  // Stop timer
  stopAutoSlide();

  // Moving slides
  model.state.slider.currentSlide = slide;
  sliderView.slidesMove(slide);

  // Start timer again
  startAutoSlide();
};

// Auto-slide
let autoSlideTimer;
const startAutoSlide = function () {
  autoSlideTimer = setInterval(() => {
    controlNextSlide();
  }, 4000);
};

const stopAutoSlide = () => clearInterval(autoSlideTimer);

// Movies
const initMovies = function () {
  moviesView._initParent();
  moviesView.render(model.state.homeMovies);
  moviesView.initRows();
};

// Search results
const controlSearch = async function () {
  try {
    // Storing user's input on search bar
    const inputValue = navView.getInputValue();

    // Clearing input
    navView.clearInput();

    // Clearing previously stored results
    model.state.results = [];

    if (!inputValue) return;

    // Calling API with the search bar user's input (this stores API response in model.state.results)
    await model.getMoviesAndShowsByQuery(inputValue);

    // Setting currentView to 'search results'
    model.setView('results');

    // Setting navbar postion correctly
    controlNavDisplay();

    // Render results
    searchBookmarksView.render(model.state.results, model.state.currentView);
    searchBookmarksView.scrollToTop();
  } catch (err) {
    // Rendering error modal
    errorView._openErrorModal(err.message);
  }
};

// Bookmarks
const controlRenderBookmarks = function () {
  if (model.state.currentView === 'bookmarks') {
    searchBookmarksView.scrollToTop();
  } else {
    if (model.state.bookmarks.length === 0) {
      errorView._openErrorModal('No bookmarks yet :)');
      return;
    }

    // Setting currentView to 'bookmarks'
    model.setView('bookmarks');

    // Setting navbar position correctly
    controlNavDisplay();

    searchBookmarksView.render(model.state.bookmarks, model.state.currentView);
    searchBookmarksView.scrollToTop();
  }
};

const controlAddRemoveBookmarks = function () {
  if (model.isBookmarked()) {
    model.removeFromBookmarks();
    modalView.updateBtnBookmarks('removed');
  } else {
    model.pushToBookmarks(model.state.currentlyDisplayedInModal);
    modalView.updateBtnBookmarks('added');
  }

  if (model.state.currentView === 'bookmarks') {
    searchBookmarksView.render(model.state.bookmarks, model.state.currentView);
  }
};

const controlLoadBookmarks = function () {
  const bookmarks = localStorage.getItem('bookmarks');
  if (bookmarks) model.state.bookmarks = JSON.parse(bookmarks);
};

const controlClearAllBookmarks = function () {
  model.state.bookmarks = [];
  model.persistBookmarks();
  searchBookmarksView.render(model.state.bookmarks, model.state.currentView);
};

// Modal
const controlOpenModal = async function (e, el) {
  try {
    // Storing id & media type
    const id = el.dataset.movieId;
    const mediaType = el.dataset.mediaType;

    // Getting movie/show by id & media type
    const movieData = await model.getMovieOrShowById(id, mediaType);

    // Checking what state the bookmarks button should be in
    if (model.isBookmarked()) modalView.updateBtnBookmarks('added');
    if (!model.isBookmarked()) modalView.updateBtnBookmarks('removed');

    // Showing modal with data about the clicked movie/show
    modalView.openModal(movieData);
  } catch (err) {
    errorView._openErrorModal(err.message);
  }
};

const controlWatchTrailer = async function () {
  try {
    window.open(await model.getMovieOrShowTrailer(), '_blank');
  } catch (err) {
    errorView._openErrorModal(err.message);
  }
};

/////////////////////////////////////////////

const init = async function () {
  try {
    // localStorage
    controlLoadBookmarks();
    // Home
    await model.getHomeMoviesAndShows();
    controlInitHome(); // initSlider() + initMovies()
    // Navbar
    initNavbar();
    // Modal
    modalView.addHandlerOpen(controlOpenModal);
    modalView.addHandlerBtnBookmarks(controlAddRemoveBookmarks);
    modalView.addHandlerWatchTrailer(controlWatchTrailer);
    // Bookmarks
    searchBookmarksView.addHandlerBtnHome(controlInitHome);
    searchBookmarksView.addHandlerClearAll(controlClearAllBookmarks);
  } catch (err) {
    errorView._openErrorModal(err.message);
  }
};
init();
